if (!customElements.get('options-picker')) {
  customElements.define(
    'options-picker',
    class OptionsPicker extends HTMLElement {
      connectedCallback() {
        this.handleClick = this.handleClick.bind(this);
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      handleClick(event) {
        const option = event.target.closest('[data-option]');
        if (!option || option.classList.contains('is-disabled') || option.disabled) return;
        this.selectOption(option);
      }

      selectOption(option) {
        if (option.classList.contains('is-active')) return;

        const url = option.dataset.variantUrl;
        if (!url) return;

        const group = option.closest('.options-picker__grid');
        if (group) {
          group.querySelectorAll('[data-option].is-active').forEach((el) => {
            el.classList.remove('is-active');
            el.setAttribute('aria-pressed', 'false');
          });
        }
        option.classList.add('is-active');
        option.setAttribute('aria-pressed', 'true');

        this.dispatchEvent(
          new CustomEvent('product:rerender', {
            bubbles: true,
            detail: { url },
          })
        );
      }
    }
  );
}
